export class UnderwritingReportApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getUnderwritingReportLoanByLoanId({ loanId }) {
    return this.#http.get(`/UnderwritingReport/loan/${loanId}`);
  }

  async getUnderwritingReportByReportId({ reportId }) {
    return this.#http.get(`/UnderwritingReport/${reportId}`);
  }
}
